/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import { useId, useMemo, useState } from 'react';
import { useAuth } from '../../../Contexts/AuthProvider';
import AddressBody from '../../../features/Address/AddressBody';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import { TextCapitalize } from '../../../utils/TextFormatter';
import { handleUpdateAddressOpe } from '../UserProfileOperation';

function AddressType({ isShow, type, onClick }) {
    const labelId = useId();
    if (!isShow) return null;
    return (
        <label
            htmlFor={labelId}
            className="inline-flex items-center justify-start text-sm text-primary"
            onClick={(e) => onClick(e, type)}
            role="button"
            tabIndex={-1}
        >
            <input
                type="radio"
                id={labelId}
                name="AddressType"
                value={type}
                className="w-4 h-4 text-primary border border-primary rounded-md"
            />
            <span className="ml-2 capitalize">{type}</span>
        </label>
    );
}

function AddressModifyModal({ closeModal, data, type }) {
    const [formData, setFormData] = useState({ status: 'active', ...data });
    const [addressType, setAddressType] = useState('');
    const [loading, setLoading] = useState(false);
    const { setMessage } = useTemplate();
    const { authInfo, authStateUpdated } = useAuth();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleAddressType = (e, t) => {
        setAddressType(`address${TextCapitalize(t)}`);
    };

    const handleOnSubmit = (e) => {
        e?.preventDefault();
        setLoading(true);
        handleUpdateAddressOpe({
            id: authInfo?.data?.id,
            userId: authInfo?.data?.id,
            addressType: type,
            ...formData
        })
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                authStateUpdated();
                closeModal();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error?.toString(0) });
            });
    };

    useMemo(() => {
        const filterData = authInfo?.data?.[addressType];

        const payloadData = {
            status: 'active',
            type: filterData?.type,
            id: authInfo?.data?.id,
            userId: authInfo?.data?.id,
            firstName: filterData?.firstName,
            lastName: filterData?.lastName,
            fullName: filterData?.fullName,
            organization: filterData?.organization,
            email: filterData?.email,
            phone: filterData?.phone,
            address: filterData?.address,
            country: filterData?.country,
            countryFull: filterData?.countryFull,
            city: filterData?.city,
            state: filterData?.state,
            zip: filterData?.zip
        };
        if (addressType) {
            setFormData({ addressType: type, ...payloadData });
        }
    }, [addressType, authInfo.data, type]);

    return (
        <div>
            <form onSubmit={handleOnSubmit}>
                <div className="flex justify-start items-center gap-3 pb-5">
                    <AddressType
                        isShow={data?.addressType?.toString() !== 'administrative'}
                        type="administrative"
                        onClick={(e) => handleAddressType(e, 'administrative')}
                    />
                    <AddressType
                        isShow={data?.addressType?.toString() !== 'billing'}
                        type="billing"
                        onClick={(e) => handleAddressType(e, 'billing')}
                    />
                    <AddressType
                        isShow={data?.addressType?.toString() !== 'technical'}
                        type="technical"
                        onClick={(e) => handleAddressType(e, 'technical')}
                    />
                </div>
                <div className="mb-6">
                    <AddressBody formData={formData} onChange={handleChange} />
                    <p className="text-xs text-error mt-3">*All Fields Are Required!</p>
                </div>

                <div className="flex justify-end gap-x-2">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Save" btnType="submit" loading={loading} />
                </div>
            </form>
        </div>
    );
}

export default AddressModifyModal;
